import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[dateMask]'
})
export class DateMaskDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    let value = event.target.value.replace(/[^0-9/]/g, ''); // only numbers and "/"
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    // max 10 chars
    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    let newValue = value.replace(/^(\d{2})\/?(\d{0,2})\/?(\d{0,4})?.*/, (_, m, d, y) => {
      let result = m;
      if (d) result += '/' + d;
      if (y) result += '/' + y;
      return result;
    });

    event.target.value = newValue;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);
    const isSlash = event.key === '/';

    if (!isNumber && !isSlash && !allowedKeys.includes(event.key)) {
      event.preventDefault(); // prevent invalid chars
    }
  }
}